import { DEFAULT_DATE } from '../utilities/constants';
import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const inspectionListQuery = gql`
  query assetInspectionsFeed(
    $siteId: Int!
    $disciplineId: Int!
    $lastModified: DateTime!
    $isLeadInspector: Boolean!
  ) {
    assetInspectionsFeed(
      siteId: $siteId
      disciplineId: $disciplineId
      lastModified: $lastModified
      isLeadInspector: $isLeadInspector
    ) {
      inspectionId
      workPackageId
      assetInspectionStatus
    }
  }
`;

const inspectionList = (siteId: number, disciplineId: number) =>
  client.query({
    query: inspectionListQuery,
    variables: {
      siteId,
      disciplineId,
      lastModified: DEFAULT_DATE,
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  });

export { inspectionList };
